'use strict';
/**
 * Make certain getters enumnerable
 *
 * This can be used to add additional getters that are enumerable and hence
 * show up on an `Object.keys()` call.
 *
 * @param {Object} object - The object it should be applied to
 * @param {Array.<String>} fields - The fields that should be made enumnerable
 */

var addEnumerableGetters = function addEnumerableGetters(object, fields) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var field = _step.value;
      var prop = void 0;
      var proto = object; // Walk up the proottype chain until a property with the given name is
      // found

      while (prop === undefined) {
        proto = Object.getPrototypeOf(proto);

        if (proto === null) {
          throw new Error("no getter named '".concat(field, "' found"));
        }

        prop = Object.getOwnPropertyDescriptor(proto, field);
      } // There is a property with the correct name, but it's not a getter


      if (prop.get === undefined) {
        throw new Error("no getter named '".concat(field, "' found"));
      }

      Object.defineProperty(object, field, {
        enumerable: true,
        get: prop.get
      });
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};
/**
 * Makes all properties with a leading underscore non-enumerable.
 *
 * @param {Object} object - The object it should be applied to
 */


var hidePrivateFields = function hidePrivateFields(object) {
  for (var key in object) {
    if (key[0] === '_') {
      Object.defineProperty(object, key, {
        enumerable: false
      });
    }
  }
};

module.exports = {
  addEnumerableGetters: addEnumerableGetters,
  hidePrivateFields: hidePrivateFields
};